var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.16245 9.64781L2.54109 11.0252C2.63834 11.1228 2.75393 11.2003 2.88123 11.2532C3.00852 11.3061 3.145 11.3333 3.28284 11.3333C3.56374 11.3333 3.82782 11.2232 4.02588 11.0252L5.50938 9.54167C5.60705 9.44441 5.68456 9.32882 5.73743 9.20153C5.7903 9.07424 5.8175 8.93775 5.81747 8.79992C5.81747 8.51901 5.70743 8.25493 5.50938 8.05688L4.42459 6.97209C4.67851 6.4124 5.03155 5.90323 5.46666 5.46917C5.90068 5.03301 6.40979 4.67869 6.96957 4.42322L8.05436 5.50801C8.15161 5.60569 8.2672 5.68319 8.3945 5.73606C8.52179 5.78893 8.65827 5.81613 8.79611 5.8161C9.07701 5.8161 9.34109 5.70607 9.53915 5.50801L11.0239 4.02581C11.1217 3.92838 11.1993 3.81257 11.2522 3.68505C11.3051 3.55753 11.3322 3.42081 11.332 3.28277C11.332 3.00186 11.222 2.73778 11.0239 2.53973L9.64789 1.16367C9.33203 0.846521 8.89579 0.666586 8.44789 0.666586C8.35339 0.666586 8.26278 0.674352 8.17345 0.689886C6.42847 0.977265 4.69773 1.90542 3.30096 3.30089C1.90549 4.69506 0.978631 6.42451 0.687369 8.17468C0.599343 8.7093 0.77669 9.25946 1.16245 9.64781Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phoneIcon.2401281c674586f850b756d9a4093086.svg";
export { ForwardRef as ReactComponent };